<template>
	<div>
		<div v-if="!userLoan">
			اطلاعات کامل نمی باشد
		</div>
		<div style="direction: rtl;" v-else>
			<div style="text-align: center;margin-bottom: 5px;font-size: 16pt;position: relative;">
				دفترچه اقساط
			</div>
			<div style="text-align: center;margin-bottom: 20px;font-size: 13pt;position: relative;">
				قرارداد فروش اقساطی {{ businessTitle }}
			</div>
			<table style="border-collapse: collapse;width: 100%;margin-top: 10px;margin-bottom: 10px;border:1px solid #000;">
				<thead>
					<tr>
						<th style="width: 23%;padding: 1px 3px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">شماره و عنوان پرونده</th>
						<th style="width: auto;padding: 1px 3px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">نام و نام خانوادگی</th>
						<th style="width: 12%;padding: 1px 3px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">تاریخ قرارداد</th>
						<th style="width: 15%;padding: 1px 3px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">تعداد اقساط</th>
						<th style="width: 15%;padding: 1px 3px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">مبلغ قسط</th>
					</tr>
				</thead>
				<tbody>
					<tr style="">
						<td style="padding: 3px 3px;border-left: 1px solid #000;">
							<div style="text-align: center;font-size: 10pt;height:100%">
								<div style="padding: 0 2px;">{{ String(userLoan.code).toPersianDigits() }}</div>
								<div style="font-size: 10px;">({{ userLoan.loanModel.title }})</div>
							</div>
						</td>
						<td style="padding: 3px;text-align: center;font-size: 10pt;border-left: 1px solid #000;">{{ userLoan.memberModel.fullName }}</td>
						<td style="padding: 3px;text-align: center;font-size: 10pt;border-left: 1px solid #000;">{{ userLoan.startDate_Persian.date.toPersianDigits() }}</td>
						<td style="padding: 3px;text-align: center;font-size: 10pt;border-left: 1px solid #000;">{{ String(userLoan.month).toPersianDigits() }}</td>
						<td style="padding: 3px;text-align: center;font-size: 10pt;border-left: 1px solid #000;">
							<div class="mb-1">{{ String(userLoan.installment).toPriceFormat().toPersianDigits() }}</div>
							<div><small>تومان</small></div>
						</td>
					</tr>
				</tbody>
			</table>

			<div style="min-height:200px">
				<table style="border-collapse: collapse;margin-top: 5px;margin-bottom: 5px;border:1px solid #000;width: 100%">
					<thead>
						<tr>
							<th style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">شماره قسط</th>
							<th style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">تاریخ سررسید</th>
							<th style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">تاریخ پرداخت</th>
							<th style="padding: 3px;text-align: center;font-size: 9pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">مبلغ پرداختی</th>
							<th style="padding: 3px;text-align: center;font-size: 9pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">زودکرد</th>
							<th style="padding: 3px;text-align: center;font-size: 9pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">دیرکرد</th>
							<th style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">جریمه</th>
							<th style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">شماره کارت</th>
							<th style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">نقدی</th>
							<th style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">واریزی</th>
							<th style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">POS</th>
							<th style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;">توضیحات</th>
						</tr>
					</thead>
					<tbody>
						<tr style="" v-for="(payment, index) in userLoan.loanPayments" :key="payment.id">
							<td style="padding: 3px 10px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;border-left: 1px solid #000;">{{ String(index + 1).toPersianDigits() }}</td>
							<td style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;border-left: 1px solid #000;overflow: hidden;">{{ payment.targetMonth_Persian.date.toPersianDigits() }}</td>
							<td style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;border-left: 1px solid #000;overflow: hidden;">{{ payment.saveDate_Persian.year != 0 ? payment.saveDate_Persian.date.toPersianDigits() : '' }}</td>
							<td style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;border-left: 1px solid #000;overflow: hidden;">{{ String(payment.amount || '').toPriceFormat().toPersianDigits() }}</td>
							<td style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;border-left: 1px solid #000;overflow: hidden;">{{ payment.delayDay < 0 ? String(payment.delayDay).toPersianDigits() : '' }}</td>
							<td style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;border-left: 1px solid #000;overflow: hidden;">{{ payment.delayDay > 0 ? String(payment.delayDay).toPersianDigits() : '' }}</td>
							<td style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;border-left: 1px solid #000;">{{ payment.delayPrice > 0 ? String(payment.delayPrice).toPriceFormat().toPersianDigits() : '' }}</td>
							<td style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;border-left: 1px solid #000;"></td>
							<td style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;border-left: 1px solid #000;"></td>
							<td style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;border-left: 1px solid #000;"></td>
							<td style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;border-left: 1px solid #000;"></td>
							<td style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;"></td>
						</tr>
					</tbody>
				</table>
			</div>

			<div style="text-align: right;margin-top: 20px;">
				<div style="font-size: 11pt;margin-bottom: 10px">شرایط قرارداد</div>
				<div style="font-size: 10pt;margin-bottom: 10px">۱. مورد معامله به صورت تمام و کامل به رویت خریدار رسید.</div>
				<div style="font-size: 10pt;margin-bottom: 10px">۲. در صورت عدم پرداخت به موقع اقساط خریدار مکلف است روزانه ..................... ریال به عنوان خسارت قراردادی به
					فروشنده پرداخت نماید که خریدار با امضای این قرارداد پرداخت مبلغ فوق را پذیرفته است و متعهد به پرداخت آن می باشد.
				</div>
				<div style="font-size: 10pt;margin-bottom: 10px">
					۳. در صورت تأخیر حداکثر ۱۵ روز در پرداخت هر یک از اقساط بدهی خریدار تبدیل به دین حال و یکجا شده و به وسیله خریدار به
					فروشنده وکالت می دهد تا از محل اجرا یا فروش ضمانت نسبت به نقد کردن کل ثمن معامله و خسارت قراردادی موضوع بند ۲ اقدام نماید.
				</div>
				<div style="font-size: 10pt;margin-bottom: 10px">
					۴. شماره تلفن .......................... به عنواان شماره تماس خریدار می باشد و در صورت تغییر، خریدار موظف است
					شماره جدید خود را به فروشنده اعلام و مسئولیت خسارت ناشی از تغییر شماره و در دسترس نبودن خریدار به عهده خریدار است.
				</div>
				<div style="font-size: 10pt;margin-bottom: 10px">
					۵. خریدار از قیمت نقدی کالا در تاریخ معامله آگاه می باشد و با میل و رغبت و استعلام قیمت روز کالا از بازار اقدام به خرید نموده و قیمت فروش
					غیر نقدی را پذیرفته و در این مورد هیچ گونه اعتراضی ندارد.
				</div>
				<div style="font-size: 10pt;margin-bottom: 10px">
					۶. در صورت عدم پرداخت به موقع اقساط طلای ضمانت آب شده و به نرخ روز محاسبه و از حساب خریدار کسر می گردد و در صورت
					وجود اضافه مابقی به خریدار تحویل داده می شود.
				</div>
				<div style="font-size: 10pt;margin-bottom: 10px">
					۷. در صورت فسخ معامله و عدم پرداخت اقساط، هزینه کارکرد و افت جنس مورد نظر از طریق پیش پرداخت با طلای ضمانت
					خریداری می گردد.
				</div>
				<div style="font-size: 10pt;margin-bottom: 10px">
					۸. طرفین با توافق رسیدگی به موارد اختلاف فی مابین ناشی از این قرارداد به کمیسیون شکایت اتحادیه صنفی مربوطه در شهر مرودشت
					واگذار کرده اند و رأی و نظر اتحادیه به عنوان نظر مورد قبول طرفین می باشد.
				</div>
				<div style="font-size: 10pt;margin-bottom: 10px">
					۹. طرفین در صحت و سلامت عقلی و هوشیاری کامل پس از مطالعه مفاد قرارداد و پذیرش مفاد آن اقدام به امضاء قرارداد نموده اند و
					حق هرگونه اعتراضی را به موارد مندرج از خود سلب نموده اند.
				</div>
			</div>

			<div style="font-size: 10pt;margin-top: 30px;">
				هیچگونه حق فسخی وجود ندارد.
			</div>

			<div style="font-size: 10pt;display: flex;margin-top: 10px;">
				<div style="width: 50%;padding: 20px 0;text-align: center;">
					امضا و اثر انگشت فروشنده
					<br />
					{{ businessTitle }}
				</div>
				<div style="width: 50%;padding: 20px 0;text-align: center;">
					امضا و اثر انگشت خریدار: آقا/خانم
					<br />
					{{ userLoan.memberModel.fullName }}
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import { get } from 'vuex-pathify'
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { sumBy } from 'lodash'

	export default {
		name: 'UserLoanPrint',
		components: {
		},
		props: {
			userLoanId: {
				type: String,
			},
			area: {
				type: String,
				default: 'admin'
			}
		},
		data: () => ({
			html: '',
			userLoan: null,
			assurances: [],
			coinTypes: [{ id: 0, title: '-' }, { id: 1, title: 'ربع سکه' }, { id: 2, title: 'نیم سکه' }, { id: 3, title: 'تمام بهار' }, { id: 4, title: 'گرمی پارسیان و ...' }],
		}),
		mounted() {
			this.fillHtml()
		},
		computed: {
			...get('siteConfig', [
				'fullTitle', 'baseUrl'
			]),
			...get('appSettings', [
				'settings'
			]),
			...get('auth', [
				'getCurrentUser',
			]),
			businessTitle() {
				return this.area === 'agent' ? this.getCurrentUser?.userData?.businessName : this.settings?.businessTitle || ''
			},
			loginUrl() {
				return `${this.baseUrl}/login/${this.customerCode}/`
			},
			currentUser() {
				var user = this.getCurrentUser
				if (user && user.userData) { return `${user.userData.fullName}` }
				return ''
			},
			customerCode() {
				var user = this.getCurrentUser
				return user?.userData?.customer?.code || ''
			}
		},
		methods: {
			fillHtml() {
				this.getUserLoan().then(res => {
					this.userLoan = res
					this.$nextTick(() => {
						this.$emit('ready')
					})
				})
				// this.html = `مدیریت محترم حسابداری <span style="font-weight:bold">اداره مورد نظر</span>\r\nبا سلام و احترام،`
			},
			getUserLoan() {
				return api.get(`${this.area}/userLoan/get/` + this.userLoanId)
					.catch(err => {
						toast.error(err.message)
					})
			},
			loadAssurances() {
				return api.get('admin/Assurance/ListByUserLoanId/' + this.userLoanId + '/false', null)
					.catch(err => {
						toast.error(err.message)
					})
			},
			sumGoldWeights() {
				return sumBy(this.assurances.filter(x => x.assuranceType === 4 && x.coinType === 0), x => x.goldWeight).toString().toPersianDigits()
			}
		}
	}
</script>
<style scoped></style>